import type { PortfolioCategoryId } from "web_myplann/Portfolio/Types/portfolioCategory";

export const togglePortfolioCategory = (
	categories: PortfolioCategoryId[],
	id: PortfolioCategoryId,
	available: PortfolioCategoryId[],
): PortfolioCategoryId[] => {
	const shown = categories.length === 0 ? available : categories;
	const next = shown.includes(id)
		? shown.filter((category) => category !== id)
		: [...shown, id];

	return next.length === available.length ? [] : next;
};
